// ── CONFIG ─────────────────────────────────────────────
const CLOUD_NAME    = 'dqvcw2ijp';
const UPLOAD_PRESET = 'Shopify_COCOBEAR';  // match EXACT casing in Cloudinary dashboard
// ────────────────────────────────────────────────────────

// FIX #1 #2 #3: IDs now match contact-form.liquid (cb- prefix)
const fileInput    = document.getElementById('fileInput');
const statusEl     = document.getElementById('cb-upload-status');
const previewImg   = document.getElementById('cb-preview-img');
const urlField     = document.getElementById('cloudinary-url-field');
const submitBtn    = document.getElementById('submit-btn');
const messageField = document.getElementById('ContactMessage');
const dropzone     = document.getElementById('cb-dropzone');

let uploadedUrl = '';

// FIX #4: use classList to match the .dragging CSS already in the liquid file
dropzone.addEventListener('dragover', e => {
  e.preventDefault();
  dropzone.classList.add('dragging');
});
dropzone.addEventListener('dragleave', () => {
  dropzone.classList.remove('dragging');
});
dropzone.addEventListener('drop', e => {
  e.preventDefault();
  dropzone.classList.remove('dragging');
  if (e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]);
});

fileInput.addEventListener('change', e => {
  if (e.target.files[0]) handleFile(e.target.files[0]);
});

function handleFile(file) {
  if (file.size > 10 * 1024 * 1024) {
    setStatus('error', 'File exceeds 10 MB limit.');
    return;
  }
  if (!file.type.startsWith('image/')) {
    setStatus('error', 'Please select an image file.');
    return;
  }
  uploadToCloudinary(file);
}

async function uploadToCloudinary(file) {
  setStatus('uploading', 'Uploading…');
  submitBtn.disabled = true;

  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', UPLOAD_PRESET);
  formData.append('folder', 'shopify-contact');

  try {
    const res = await fetch(
      `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
      { method: 'POST', body: formData }
    );

    const data = await res.json();

    if (data.error) {
      throw new Error(data.error.message);
    }
    if (!res.ok) {
      throw new Error('Upload failed: ' + res.statusText);
    }

    uploadedUrl = data.secure_url;
    previewImg.src = uploadedUrl;
    previewImg.style.display = 'block';
    setStatus('success', '✓ Image uploaded');
    submitBtn.disabled = false;
  } catch (err) {
    setStatus('error', 'Upload error: ' + err.message);
    submitBtn.disabled = false;
  }
}

// Combine textarea message + image URL into contact[body]
document.querySelector('form').addEventListener('submit', function(e) {
  const note = messageField.value.trim();
  const parts = [];
  if (note)        parts.push(note);
  if (uploadedUrl) parts.push('\n\nInspiration image: ' + uploadedUrl);
  urlField.value = parts.join('');

  // Image is optional — uncomment the 2 lines below to make it required
  // if (!uploadedUrl) {
  //   e.preventDefault();
  //   setStatus('error', 'Please upload an image first.');
  // }
});

function setStatus(type, msg) {
  statusEl.textContent = msg;
  statusEl.style.color =
    type === 'error'   ? '#dc2626' :
    type === 'success' ? '#16a34a' : '#563728';
}
